<template>
  <v-app class="bgLightGreen" id="inspire">
    <Header header-text="lng_login_title"></Header>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12 pa-3 login-block">
            <h2
              class="headline headingColor--text font-weight-bold text-xs-center"
            >
              Log In
            </h2>
            <v-card-text>
              <v-form ref="login" v-model="valid" lazy-validation>
                <v-layout column align-center justify-center>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      pt1
                      :label="translate('lng_login_username')"
                      v-model="name"
                      :rules="nameRules"
                      required
                      v-on:keyup.enter="validate"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      pt1
                      :label="translate('lng_login_password')"
                      v-model="password"
                      type="text"
                      v-on:keyup.enter="validate"
                    />
                  </v-flex>
                  <p class="choose-language">Choose your language and log in</p>
                  <v-flex xs12 sm6 md4 d-flex mxWide lang>
                    <v-select
                      label="Standard"
                      :items="langugaes"
                      @change="changeLanguage()"
                      v-model="selectedLanguage"
                    >
                      // Don't forget your props
                      <template v-slot:selection="{ item, index }">
                        <country-flag :country="item.flag" size="normal" />
                        <span class="flags pl-2">{{ item.name }}</span>
                      </template>
                      <template v-slot:item="{ item, index }">
                        <country-flag :country="item.flag" size="normal" />
                        <span class="flags pl-2">{{ item.name }}</span>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-btn
                    :loading="loginLoading"
                    :disabled="loginLoading"
                    @click="validate"
                    color="primary"
                    class="login-btn mt-0"
                    >{{ translate("lng_button_login") }}</v-btn
                  >
                  <span
                    @click="forgotPasswordClicked"
                    class="forgot-password-btn"
                  >
                    {{ translate("forgot_password_title") }}</span
                  >
                  <p class="warning-error mt-2" v-if="error">{{ error }}</p>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <reset-password-dialog
      :dialog="closePasswordDialog"
      :openDialog="resetPassDialog"
      :userName="name"
      :selected-language="this.selectedLanguage.lang"
      :on-response="showResponseAlert"
    />
    <set-password-dialog
      :dialog="closeSetPasswordDialog"
      :openDialog="setPassDialog"
      :token="forgotPassToken"
      :serial="name"
      :on-success="onSetPasswordSuccess"
    />
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    />
  </v-app>
</template>

<script>
import CountryFlag from "vue-country-flag";
import Header from "../components/Header";
import UserService from "../services/user-service";
import GlobalService from "../services/global-service";
import Langugaes from "../components/internationalization/languages";
// import I18n from "../components/internationalization/i18n";
import ResetPasswordDialog from "../components/ResetPasswordDialog";
import SetPasswordDialog from "../components/SetPasswordDialog";
import router from "../router.js";
import { mapGetters } from "vuex";
import FlashMessage from "../components/FlashMessage";

export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [v => !!v || "Name is required"],
    password: "",
    response: {},
    error: "",
    loginLoading: false,
    langugaes: Langugaes.languages,
    selectedLanguage: Langugaes.languages[1],
    currentLang: window.selectedLang,
    resetPassDialog: false,
    setPassDialog: false,
    forgotPassToken: "",
    alertToggle: false,
    flashMessageData: {}
  }),
  async mounted() {
    document.getElementsByTagName("html")[0].className = "login-page";
    // this.currentLang = await GlobalService.getLang(this.selectedLanguage.lang);
    this.chooseLanguage();
    this.name = this.getUser.name;
    this.openSetPasswordFromHash();
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    translate(text) {
      if (this.currentLang[text]) {
        return this.currentLang[text];
      } else if (window.ukLang[text]) {
        return window.ukLang[text];
      } else {
        return text;
      }
    },
    setLocalStoreLang(lang) {
      localStorage.setItem("language", lang);
    },
    getLocalStoreLang() {
      return localStorage.getItem("language");
    },

    // change langauge function
    async chooseLanguage() {
      let storageLang = this.getLocalStoreLang();
      if (storageLang) {
        let index = Langugaes.languages.findIndex(e => e.lang == storageLang);
        if (index >= 0) {
          this.selectedLanguage = Langugaes.languages[index];
          this.currentLang = await GlobalService.getLang(
            Langugaes.languages[index].lang
          );
          window.selectedLang = this.currentLang;
          // window.I18n = new I18n(Langugaes.languages[index].lang);
        }
      } else {
        this.changeLanguage();
      }
    },
    // validate the login fields
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.login.validate()) {
          await this.login();
        }
      });
    },
    // login function
    async login() {
      this.error = "";
      this.loginLoading = true;
      let response;
      try {
        response = await UserService.login(this.name, this.password);
      } catch (e) {
        this.error = "Try again later!!";
        this.loginLoading = false;
      }
      if (!response.status) {
        this.error = "";
        this.loginLoading = false;
        this.completeLogin(this.name, response);
      } else {
        this.loginLoading = false;
        this.error = "Login details incorrect";
      }
    },
    // store language to session
    async changeLanguage() {
      this.currentLang = await GlobalService.getLang(
        this.selectedLanguage.lang
      );
      window.selectedLang = this.currentLang;
      // window.I18n = new I18n(this.selectedLanguage.lang);
      this.setLocalStoreLang(this.selectedLanguage.lang);
      this.$store.commit("global/setLanguage", this.selectedLanguage.lang);
    },
    forgotPasswordClicked() {
      this.resetPassDialog = true;
    },
    closePasswordDialog() {
      this.resetPassDialog = false;
    },
    parseForgotPassToken() {
      const hash = window.location.hash || "";
      const query = hash.replace(/^#/, "");
      const parts = query.split("&");
      for (let i = 0; i < parts.length; i++) {
        const eq = parts[i].indexOf("=");
        if (eq === -1) {
          continue;
        }
        if (parts[i].slice(0, eq) === "forgotpass") {
          return decodeURIComponent(parts[i].slice(eq + 1));
        }
      }
      return "";
    },
    openSetPasswordFromHash() {
      const token = this.parseForgotPassToken();
      if (!token) {
        return;
      }
      this.forgotPassToken = token;
      this.setPassDialog = true;
    },
    closeSetPasswordDialog() {
      this.setPassDialog = false;
    },
    completeLogin(name, response) {
      const user = {
        name,
        token: response.token,
        master: response.master,
        credentials: response.credentials || "full"
      };
      this.$store.commit("user/setUser", user);
      localStorage.setItem("user", JSON.stringify(user));
      if (window.location.hash) {
        history.replaceState(
          null,
          document.title,
          window.location.pathname + window.location.search
        );
      }
      router.push(`/#${name}`);
    },
    onSetPasswordSuccess(response, serial) {
      this.forgotPassToken = "";
      this.name = serial;
      this.completeLogin(serial, response);
    },
    // to show the resposne alert on update field
    showResponseAlert(resObj) {
      this.alertToggle = true;
      this.flashMessageData = {
        // saved: resObj.status ? 'lng_save_notok' : 'lng_save_ok',
        messageText: resObj.status
          ? `${this.translate("lng_save_notok")}`
          : `${this.translate("lng_receive_email")}`,
        showRegisterButton: false,
        color: resObj.status ? "red" : "rgba(76, 175, 80, 0.9)"
      };
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    }
  },
  // import components for Header and languages country flags
  components: {
    Header,
    CountryFlag,
    ResetPasswordDialog,
    SetPasswordDialog,
    FlashMessage
  }
};
</script>
